import { Box, Tab, Tabs } from "@mui/material";
import { useEffect, useState } from "react";
import { BorrowerService } from "../../borrowerService";
import { SummaryLoader } from "./summaryLoader";
import { useTranslation } from "react-i18next";
import { LoanSummary } from "./loanSummary";
import { LocalStorageKey } from "../../../../constants/localStorageKeys";

export const BorrowerSummary = () => {
  const [activeLoans, setActiveLoans] = useState([]);
  const [loading, setLoading] = useState(true);
  const [selectedTab, setSelectedTab] = useState(0);
  const { t } = useTranslation();

  useEffect(() => {
    const borrowerService = new BorrowerService();
    borrowerService
      .getActiveLoans()
      .then((resp) => {
        if (resp.data && resp.data.length > 0) {
          setActiveLoans(resp.data);
          if (sessionStorage.getItem(LocalStorageKey.activeLoanId)) {
            const index = resp.data.findIndex(
              (loan) => loan.loanId === sessionStorage.getItem(LocalStorageKey.activeLoanId),
            );
            setSelectedTab(index);
          } else {
            sessionStorage.setItem(LocalStorageKey.activeLoanId, resp.data[0].loanId);
          }
        }
      })
      .finally(() => {
        setLoading(false);
      });
  }, []);

  const handleTabChange = (event, newValue) => {
    setSelectedTab(newValue);
    sessionStorage.setItem(LocalStorageKey.activeLoanId, activeLoans[newValue].loanId);
  };

  return (
    <Box className="flex flex-col flex-0">
      {loading ? (
        <SummaryLoader />
      ) : activeLoans.length > 0 ? (
        <>
          <Tabs
            value={selectedTab}
            onChange={handleTabChange}
            variant="scrollable"
            scrollButtons="auto"
          >
            {activeLoans.map((loan, index) => (
              <Tab
                key={loan.id || index}
                label={loan.name || `Loan ${loan.applicationId}`}
              />
            ))}
          </Tabs>
          <Box className="grid grid-cols-1 gap-4 mt-4">
            {activeLoans[selectedTab] && (
            <LoanSummary
              key={activeLoans[selectedTab].loanId}
              loanId={activeLoans[selectedTab].loanId}
            />)}
          </Box>
        </>
      ) : (
        <Box>{t("borrower.summary.noActiveLoans")}</Box>
      )}
    </Box>
  );
};
